<template>
    <common-modal
        height="medium"
        width="extra-large"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <div class="content">
            <div v-if="providers[0]?.practice?.practiceType === PracticeTypeEnum.PHYSICIAN" class="providers-list">
                <practice-member-card
                    v-for="member in providers"
                    :key="member.id"
                    :physician="member"
                    :showNetworkInclusionStatus="false"
                    :showMasterUserAuthorities="false"
                    :showCardAvailability="false"
                ></practice-member-card>
            </div>
            <div v-else class="providers-list">
                <ancillary-member-card
                    v-for="item in providers"
                    :key="item.id"
                    :ancillary="item"
                    :showCardAvailability="false"
                ></ancillary-member-card>
            </div>
        </div>
    </common-modal>
</template>

<script>
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import PracticeMemberCard from 'components/page-elements/practice/PracticeMemberCard'
    import AncillaryMemberCard from 'components/page-elements/practice/AncillaryMemberCard'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            PracticeMemberCard,
            AncillaryMemberCard,
        },
        props: {
            referralPoolId: { type: Number, required: true },
        },
        data() {
            return {
                providers: [],
                PracticeTypeEnum,
            }
        },

        methods: {
            getReferralPoolProviders() {
                ReferralsPoolAPI.getReferralsPoolProviders(this.referralPoolId).then((response) => {
                    this.providers = response
                })
            },
        },

        mounted() {
            this.getReferralPoolProviders()
        },
    }
</script>

<style scoped lang="scss">
    .content {
        max-height: 500px;
        overflow-y: auto;
    }

    .providers-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 10px 10px;
        overflow-x: hidden;
    }
</style>
